import styled from 'styled-components';

export default styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: uppercase;
  cursor: pointer;
`;
